import type { ILessonPerformanceReportState } from '@/store/modules/report/lesson-performance-report/types';

export const state: ILessonPerformanceReportState = {
  lessonPerformance: null,
};
